import React from 'react';
import ReactDOM from 'react-dom';
import { Router } from 'react-router-dom';
import { Provider } from "react-redux";
import { AppContainer } from 'react-hot-loader';

import App from '@/template/components/App';
import store from '@/store';
import history from '@/historys';
import '@/config';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@/static/gohome.css';

// const store = initStore();

const render = Component => {
  ReactDOM.render(
    <AppContainer>
      <Router history={history}>
        <Provider store={store}>
          <Component />
        </Provider>
      </Router>
    </AppContainer>,
    document.getElementById('root')
  )
}

if (module.hot) {
  module.hot.accept(() => render(App));
  window.store = store;
}

if (localStorage.themes) {
  import(`@/static/${localStorage.themes}.css`).then(()=>{
    render(App);
  })
} else {
  render(App);
}




// WEBPACK FOOTER //
// ./src/index.js